import BaseAPI from '@/services/api/internal/tools/baseAPI';
import BaseModule from '@/store/baseModule';
import BaseService from '@/services/services/tools/baseService';
import { makeListRequest } from '@/business/apiTreatment/request/makeQueryParams';
import {
  treatsItem,
  treatsItems,
} from '@/business/apiTreatment/response/baseAPITreatment';

const attributesObjRef = {};
const attributesObj = {
  entity_nav_full_id: {
    type: '$instr',
    values: [],
  },
  staffs_in_charge_id: {
    type: '$instr~,',
    values: [],
  },
};
const datetimeFieldNames = [
  'start_datetime',
  'deadline_datetime',
  'current_action_status_datetime',
];
const dateFilter = new Date();
dateFilter.setDate(new Date().getDate() - 14);

export default (store) => {
  store.registerModule(
    ['actions', 'lightPriorities'],
    new BaseModule({
      serviceAPI: new BaseService({
        api: new BaseAPI({
          url: `${process.env.MYPREDITY_BASE_URI}/actions?light=O`,
        }),
        treatListResponse: treatsItems({
          datetimeFieldNames,
        }),
        treatCurrentResponse: treatsItem({
          datetimeFieldNames,
        }),
        treatCreateResponse: treatsItem({
          datetimeFieldNames,
        }),
      }),
      attributesObj,
      attributesObjRef,
      dateMin: dateFilter,
      makeQueryParams: makeListRequest({
        useEntities: true,
        dateField: 'end_datetime',
        dateNullable: true,
      }),
    })
  );

  const DEFAULT_COPIED_FILTERS = [
    'entity_nav_full_id',
    'staffs_in_charge_id',
    'action_plan_status',
  ];

  store.subscribeAction((action) => {
    if (action.type === 'dashboardPem/setFilterAttribute') {
      if (
        DEFAULT_COPIED_FILTERS.find((item) => item === action.payload.attribute)
      ) {
        store.dispatch('actions/lightPriorities/setFilterAttribute', {
          ...action.payload,
          reload: false,
        });
      } else if (action.payload.attribute === 'action_status_id') {
        store.dispatch('actions/lightPriorities/setFilterAttribute', {
          ...action.payload,
          attribute: 'current_action_status_type_id',
          reload: false,
        });
      }
    }
  });
};
